import { render, staticRenderFns } from "./BanReaper.vue?vue&type=template&id=515b0cd2"
import script from "./BanReaper.vue?vue&type=script&lang=js"
export * from "./BanReaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports